
























import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import 'swiper/css/swiper.css';

@Component({
  name: 'catalog-product-related',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({default: 12}) readonly limit!: number;
  @Prop() private productId: number;
  @Prop({default: 3.5}) private slides!: number;

  private products: Array<object> = [];
  private isLoading: boolean = true;

  private slideOptions: object = {
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
      enabled: true,
      nextEl: '.product__related .swiper-button-next',
      prevEl: '.product__related .swiper-button-prev'
    },
    breakpoints: {
      320: {
        slidesPerView: 1.5
      },
      600: {
        slidesPerView: 2.5
      },
      1025: {
        slidesPerView: this.slides
      }
    }
  };

  private mounted(): void {
    this.$solarClient.post('/api/catalog/product-relations', {
        product_id: this.productId,
        store_id: 1,
        type: 'relation'
      }
    ).then((response) => {
      this.products = response.data;
    }).finally(() => {
      this.isLoading = false;
    });
  }

  private updated(): void {
    setTimeout(() => {
      ('.catalog__category-list a h2').matchHeight(true);
    }, 100);
  }
}
